var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrInsuranceHome = function SvgBrInsuranceHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_2883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8555 5.2134L16.8545 0.212402L16.8555 0.214402L26.9035 10.2144H23.9955L16.8555 3.1214L6.85447 13.1224L6.85347 30.2134H9.85547V32.2124H4.85447V15.1204L2.30847 17.6674L0.855469 16.2124L4.85447 12.2134V1.2134H11.8505H11.8555V5.2134ZM9.85647 3.2134H6.85447V10.2144L9.85647 7.2124H9.85547L9.85647 3.2134ZM11.9063 32.2128L11.9153 12.2148L32.8983 12.2128L32.9073 32.2128H30.9063L30.8993 14.2118L13.8983 14.2128L13.9053 30.2138L28.9063 30.2128V32.2118L11.9063 32.2128Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9084 16.2139L15.9014 18.2129L28.8944 18.2119L28.9014 16.2129L15.9084 16.2139ZM15.9016 23.2129L28.8946 23.2119L28.9016 21.2129L15.9086 21.2139L15.9016 23.2129ZM24.3226 28.2119L15.9016 28.2129L15.9056 26.2139L24.3266 26.2129L24.3226 28.2119Z",
    fill: "#0157FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_2883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white",
    transform: "translate(0.855469 0.212891)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrInsuranceHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/br_insurance_home.bcddc1162b4f243b9159f007043fb723.svg";